import { useDialog } from '@dni-hooks/useDialog'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'

const styles = stylex.create({
  container: {
    borderRadius: 8,
    gap: 16,
    backgroundColor: colors.white,
    paddingTop: 16,
    width: 320,
  },
  button: {
    width: '100%',
  },
  blackButton: {
    backgroundColor: colors.black,
    width: '100%',
  },
})

export const DIALOG_CHECK_WEIGHT_ATTRIBUTE = 'DIALOG_CHECK_WEIGHT_ATTRIBUTE'

export interface DialogWeightAttributeProps {
  withBlackButton?: boolean
}

export const DialogWeightAttribute = ({ withBlackButton }: DialogWeightAttributeProps) => {
  const { open, closeDialog: closeDialogWeightAttribute } = useDialog(DIALOG_CHECK_WEIGHT_ATTRIBUTE)

  return (
    <Dialog disablePortal open={open} onClose={closeDialogWeightAttribute}>
      <DialogContent>
        <VStack rootStyle={[styles.container]}>
          <Box display="flex" justifyContent="center">
            <Text variant="h4">無法加入</Text>
          </Box>
          <Box>
            <Text variant="body" color={colors.grey800}>不能同時在購物車中加入大、小包規格的冷凍商品。</Text>
          </Box>
        </VStack>
      </DialogContent>
      <DialogActions>
        <Button
          rootStyle={withBlackButton ? styles.blackButton : styles.button}
          onClick={closeDialogWeightAttribute}
        >
          確定
        </Button>
      </DialogActions>
    </Dialog>
  )
}
